import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-error-box-message', {
    fontSize: '13px',
    lineHeight: '16px',
});

cssRule('.tb-error-no-site .tb-error-box', {
    marginTop: 0,
});

cssRule('.tb-error-box-message-first', {
    fontSize: '18px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
    margin: '16px',
});

cssRule('.tb-error-box-message-second', {
    fontSize: '14px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#666'),
    lineHeight: '21px',
    marginBottom: '28px',
});

